import { render, staticRenderFns } from "./DeleteMessage.vue?vue&type=template&id=a7f33260&scoped=true&"
import script from "./DeleteMessage.vue?vue&type=script&lang=js&"
export * from "./DeleteMessage.vue?vue&type=script&lang=js&"
import style0 from "./DeleteMessage.vue?vue&type=style&index=0&id=a7f33260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f33260",
  null
  
)

export default component.exports